import {createApp} from 'vue'
import App from './App.vue'

//路由
import router from './router'

//饿了么UI
import ElementPlus from 'element-plus'
import 'element-plus/theme-chalk/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

//多语言
import i18n from './locales/i18n';

//markdown
import 'github-markdown-css'

//开始注册
const app = createApp(App)

//全局注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

//注册饿了么UI
app.use(router).use(ElementPlus, {locale: zhCn}).mount('#app')
app.use(i18n)